import { BaseFeature, FeatureType } from '@core/shared/feature';
import { DefaultAbilityAction } from '@core/shared/ability';
export class MediaBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/media/feature","featureId":"common-media"},
      bundledItemModels: ["MediaAssetItem", "MediaAssetSubtitlesItem", "MediaAssetMappingItem"],
      // list is auto-generated by generate-model-ids
      abilityActions: [{
        action: DefaultAbilityAction.Manage,
        defaultBias: -1
      }, {
        action: 'Upload',
        defaultBias: -1
      }, {
        action: 'Select',
        defaultBias: -1
      }],
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'MediaFrontendFeature'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MediaFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'MediaBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MediaBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {},
        admin: {
          MediaAssetItem: item => {
            const id = typeof item === 'object' ? item.id : item;
            return ['media', id];
          }
        }
      }
    };
  }
}